import { render, staticRenderFns } from "./ModalHeader.vue?vue&type=template&id=9a57d086&scoped=true&"
import script from "./ModalHeader.vue?vue&type=script&lang=js&"
export * from "./ModalHeader.vue?vue&type=script&lang=js&"
import style0 from "./ModalHeader.vue?vue&type=style&index=0&id=9a57d086&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a57d086",
  null
  
)

export default component.exports